import Notification from '../UI/Notification/Notification';
import { isBirthdayToday } from './birthdayUtils';

const BirthdayNotificationComponent = ({ dateOfBirth }) =>
  isBirthdayToday(dateOfBirth) ? (
    <Notification status={'success'} message={'Wish this client Happy Birthday, it’s their birthday today!'} />
  ) : null;

export default BirthdayNotificationComponent;
